<template>
  <div>
    <app-header v-bind.sync="headerOptions"></app-header
    ><router-view></router-view>
  </div>
</template>

<script>
import AppHeader from '@/shared/components/layout/AppHeader.vue'

export default {
  name: 'Layout',
  components: { AppHeader },

  data() {
    return {
      headerOptions: {
        color: '#ffffff00'
      }
    }
  }
}
</script>

<style></style>
